<template>
<div>
    <base-header v-once pageName="공지사항" :prevBtnShow="true" history="main"></base-header>

    <section id="wrap">
        <div class="notice">
            <div class="search-input">
                <input type="search" v-model="txt" @keyup.enter ="searchList" class="search" placeholder="검색어를 입력해 주세요.">
                <button type="button" class="search" title="검색" @click="searchList"></button>
            </div>


            <ul>
                <li :class="item.importance === '1' ? 'emgc' : 'impt'"  v-for="(item , index) in list" v-bind:key="index">
                    <a>
                        <i>{{item.importance === '1' ? '긴급' : '일반'}}</i>
                        <span @click="openView(index)">{{htmlParser(item.title)}}</span>
                        <em>{{item.writeDate}}</em>
                    </a>
                </li>
            </ul>

        </div>
       <infinite-loading @infinite="infiniteHandler" spinner="waveDots" ref="InfiniteLoading">
        <div slot="no-more"></div>
        <div slot="no-results">검색된 정보가 없습니다.</div>
      </infinite-loading>
      <!-- 2026.09.18 챗봇 버튼-->
      <div class="fltMn">
          <button type="button" class="chatbot allow-click" @click="chatbot"></button>
      </div>
      <!--// 2026.09.18 챗봇 버튼-->
    </section>
</div>
</template>

<script>
var parser = new DOMParser();
import InfiniteLoading from "vue-infinite-loading";
export default {
  name: "NoticeList",
  components: {
    InfiniteLoading,
  },
  data() {
      return{
          loginGbn : this.$store.getters.loginGbn, //로그인구분
          txt : '',
          searchTxt: '',
          list:[],
          tot:0,
          offset: 0,     //현재 가지고있는 갯수
          size : 10    //한번에 가져오는 수
      };
  },
    methods: {
        htmlParser : function (titl) {
            return parser.parseFromString(titl, "text/html").body.innerText;
        },
        infiniteHandler : function($state){
        var that = this;
        var parameters = {
            offset: this.offset,
            size: this.size,
            searchTxt : this.searchTxt
        };
        this.$api.notice
            .list(parameters)
            .then(function(data) {
            that.tot = data.totCnt;  // API에서 가져온 총 카운트
            var list = data.list;   //API에서 가져온 리스트
            if (list.length) {
                that.list = that.list.concat(list);
                $state.loaded();
                that.offset += that.size;

                if (list.length < that.size) {
                $state.complete();
                }
            } else {
                $state.complete();
            }
            })
            .catch(function(error) {
            alert(error.rtMsg);
            console.log(error);
            });
        },

    searchList : function(){
        this.searchTxt = this.txt
        this.totalCnt = 0
        this.offset = 0
        this.size = 10
        this.list = []
        this.$refs.InfiniteLoading.stateChanger.reset();
    },

    openView : function(index){

        var item = this.list[index];
        var itemId = item.itemId;
        this.$utils.nativeIf.outbound.newPage('/notice/detail/?itemId='+itemId)  //새창 띄우기
    },
    chatbot: function(){
        this.$api.chatbot
        .getChatbotToken()
        .then((token) => {
          this.token = token;
          if(this.token != null){
              // this.$utils.nativeIf.outbound.outlink("https://kyowon-chatbot.ax.dalpha.so/#token="+this.token); //달파 토큰 전송
              window.location.href =  `https://kyowon-chatbot.ax.dalpha.so/#token=${encodeURIComponent(token)}&inpath=WAPLE`;
          }else {
              console.log("else token");
          }
        })
        .catch(function (error) {
          alert(error.rtMsg);
        });
    },
  }
};
</script>
